$(window).on('scroll', 'load', function () {
  if ($(document).scrollTop() >= $('.js-events-headline').outerHeight()) {
    $('.js-mobile-subscribe').addClass('visible')
  } else {
    $('.js-mobile-subscribe').removeClass('visible')
  }
});

if ($('.js-events-headline .banner__bg').length > 0) {
  $(window).on('load resize', function () {
    if (window.innerWidth > 767 && $('.js-events-headline').outerHeight() > 526) {
      const bannerHeight = $('.js-events-headline').outerHeight()
      $('.js-events-headline .banner__bg').css('height', bannerHeight);
    }
  });
}
